import { render, staticRenderFns } from "./BranchCard.vue?vue&type=template&id=1efd4ece&scoped=true&"
import script from "./BranchCard.vue?vue&type=script&lang=js&"
export * from "./BranchCard.vue?vue&type=script&lang=js&"
import style0 from "./BranchCard.vue?vue&type=style&index=0&id=1efd4ece&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efd4ece",
  null
  
)

export default component.exports